// import Template from "views/TopRightBar/Template";
// const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

// const privilege = JSON.parse(localStorage.getItem("privilege") || "{}");

// // Sleep for preparing privileges
// if (!privilege) {
//     window.location.reload();
// }
// const PrivilegeList = {
// detailShow: !!privilege["FZR01TAN"] ,
// loanTabShow: !!privilege["1YDMAHVA"] ,
// documentTabShow: !!privilege["W38QEPG3"] ,
// commentTabShow:!! privilege["VGT3ORSH"] ,
// creditTabShow: !! privilege["5ETMC1AE"], 
// payoutTabShow: !! privilege["JJ28O9VH"], 
// foirTabShow:!! privilege["8B0H0O74"] ,
// installmentTabShow: !!privilege["T9ZR417K"] ,
// installmentAdjustmentTabShow: !!privilege["O47ASZRI"],
// legalTabShow: !!privilege["PARB5JHL"] ,
// communicationLogTabShow: !!privilege["C5WZ477J"],
// customerDetailsEdit: privilege["UHJEBZIY"] === 2,
// customerDetailsContactInfoShow:!! privilege["KSFEEFKO"] ,
// customerDetailsIdInfoShow: !!privilege["UCCLLDEB"] ,
// bankingDetailsBankingInfoShow : !!privilege["BQFXGG0Q"] ,
// currentAddressEdit: privilege["9AHYE4Z9"] === 2,
// officeAddressEdit: privilege["JL1ALBJM"] ===2,
// permanentAddressEdit: privilege["4RZ00KCK"] ===2,
// statusChangeShow: !! privilege["SDHHVCUP"] ,
// professionalDetailsEdit: privilege["VENE5KRY"] === 2,
// professionalDetailsContactInfoShow: !! privilege["OME4X7CN"] ,
// professionalDetailsIncomeInfoShow:!! privilege["9HX8W61E"] ,
// referenceDetailsContactInfoShow: !!privilege["3JLC9B04"] ,
// referenceDetailsEdit: privilege["11AVVURI"] === 2,
// nomineeDetailsEdit: privilege["ZI7ZO8IC"] === 2,
// nomineeDetailsIdInfoShow:!! privilege["GP3URBBG"],
// privilegeTabShow: !! privilege["7QBW6M9L"],
// lspListTabShow: !! privilege["HHJW7JFB"],
// createNewUserShow: !! privilege["1O9SSUM3"],
// templateShow: !! privilege["EO71WTD1"],
// salesAgentShow: !! privilege["LOWN4DRV"],
// creditAgentShow: !! privilege["5FOKLXQN"],
// breTabShow: !! privilege["634TV4L6"],
// payOutRequestTabShow: !! privilege["5ETMC1AE"]




// };

// export default PrivilegeList;
const getPrivilegeList = () => {
  // localStorage can hold the literal string "undefined" (not just null), which breaks JSON.parse.
  let privilege = {};
  try {
    const raw = localStorage.getItem("privilege");
    if (raw && raw !== "undefined" && raw !== "null") {
      privilege = JSON.parse(raw);
    }
  } catch (e) {
    privilege = {};
  }

  return {
    detailShow: !!privilege["FZR01TAN"],
    loanTabShow: !!privilege["1YDMAHVA"],
    documentTabShow: !!privilege["W38QEPG3"],
    commentTabShow: !!privilege["VGT3ORSH"],
    creditTabShow: !!privilege["5ETMC1AE"],
    payoutTabShow: !!privilege["JJ28O9VH"],
    foirTabShow: !!privilege["8B0H0O74"],
    installmentTabShow: !!privilege["T9ZR417K"],
    installmentAdjustmentTabShow: !!privilege["O47ASZRI"],
    legalTabShow: !!privilege["PARB5JHL"],
    communicationLogTabShow: !!privilege["C5WZ477J"],
    customerDetailsEdit: privilege["UHJEBZIY"] === 2,
    customerDetailsContactInfoShow: !!privilege["KSFEEFKO"],
    customerDetailsIdInfoShow: !!privilege["UCCLLDEB"],
    bankingDetailsBankingInfoShow: !!privilege["BQFXGG0Q"],
    currentAddressEdit: privilege["9AHYE4Z9"] === 2,
    officeAddressEdit: privilege["JL1ALBJM"] === 2,
    permanentAddressEdit: privilege["4RZ00KCK"] === 2,
    statusChangeShow: !!privilege["SDHHVCUP"],
    professionalDetailsEdit: privilege["VENE5KRY"] === 2,
    professionalDetailsContactInfoShow: !!privilege["OME4X7CN"],
    professionalDetailsIncomeInfoShow: !!privilege["9HX8W61E"],
    referenceDetailsContactInfoShow: !!privilege["3JLC9B04"],
    referenceDetailsEdit: privilege["11AVVURI"] === 2,
    nomineeDetailsEdit: privilege["ZI7ZO8IC"] === 2,
    nomineeDetailsIdInfoShow: !!privilege["GP3URBBG"],
    privilegeTabShow: !!privilege["7QBW6M9L"],
    lspListTabShow: !!privilege["HHJW7JFB"],
    createNewUserShow: !!privilege["1O9SSUM3"],
    templateShow: !!privilege["EO71WTD1"],
    salesAgentShow: !!privilege["LOWN4DRV"],
    creditAgentShow: !!privilege["5FOKLXQN"],
    breTabShow: !!privilege["634TV4L6"],
    payOutRequestTabShow: !!privilege["5ETMC1AE"],
    loanAgreementShow: !!privilege["JYVJ2J7H"],
    blockAreaShow: !!privilege["JZGKHXZF"],
    reportingShow: !!privilege["8JWZABHF"],
    fintechWalletShow: !!privilege["HI5377YV"],
    lspBalanceShow: !!privilege["AJ90BST4"],
    refundShow: !!privilege["8AUR99PT"],
    lspSelectShow: !!privilege["AMGKO4WH"],
    // "Slidder" title — one privilege per link in the admin sidebar.
    navLeadShow: !!privilege["D87GRM08"],
    navLoanShow: !!privilege["C43IU4CH"],
    navCustomerShow: !!privilege["KVQBEWFZ"],
    navRepaymentShow: !!privilege["8R0DNS1O"],
    navCollectionShow: !!privilege["R5WTDWZB"],
    // "Reconcillation" / subtitle "Slidder Reconcillation"
    navReconcillationShow: !!privilege["VBB5QQ21"]
  };
};

export default getPrivilegeList;
